import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
} from "@mui/material";
import { EQUIPMENT_CATEGORIES } from "../types/eventTypes";

const EquipmentAssignForm = ({ onSubmit, onCancel, loading }) => {
  const [form, setForm] = useState({
    equipmentId: "",
    equipmentName: "",
    category: "Camera",
    quantity: 1,
    remarks: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      ...form,
      equipmentId: form.equipmentId || `EQ${Date.now()}`,
      quantity: Number(form.quantity) || 1,
      officeTaken: false,
      returned: false,
      takenBy: "",
      takenAt: null,
      returnedBy: "",
      returnedAt: null,
    });
  };

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Equipment Name *"
            fullWidth
            required
            disabled={loading}
            value={form.equipmentName}
            onChange={(e) =>
              setForm({ ...form, equipmentName: e.target.value })
            }
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel>Category</InputLabel>
            <Select
              value={form.category}
              label="Category"
              disabled={loading}
              onChange={(e) => setForm({ ...form, category: e.target.value })}
            >
              {EQUIPMENT_CATEGORIES.map((c) => (
                <MenuItem key={c} value={c}>
                  {c}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Quantity"
            type="number"
            fullWidth
            disabled={loading}
            value={form.quantity}
            onChange={(e) => setForm({ ...form, quantity: e.target.value })}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Remarks"
            fullWidth
            disabled={loading}
            value={form.remarks}
            onChange={(e) => setForm({ ...form, remarks: e.target.value })}
          />
        </Grid>
      </Grid>
      <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
        <Button type="submit" variant="contained" fullWidth disabled={loading}>
          Add Equipment
        </Button>
        <Button
          variant="outlined"
          color="inherit"
          onClick={onCancel}
          disabled={loading}
        >
          Cancel
        </Button>
      </Box>
    </form>
  );
};

export default EquipmentAssignForm;
